import _ from 'lodash';

// Import Actions
import {
  FETCHING_VENUE_EXPERT_PAGE,
  FETCH_VENUE_EXPERT_PAGE,
  LOADING_MORE_VENUELIST_EXPERT_PAGE,
  LOAD_MORE_VENUELIST_EXPERT_PAGE,
} from '../actions/VenueExpertActions';

// Initial State
const initialState = {
  venueexpert: {},
  totalCount: 0,
  pageNum: 1,
  pageSize: 10,
  venueList: [],
  isLoadingPage: false,
  isFetchingVenues: false,
};

const VenueExpertReducers = (state = initialState, action) => {
  switch (action.type) {

    case FETCHING_VENUE_EXPERT_PAGE:
      return {
        ...state,
        isLoadingPage: action.isLoadingPage,
      };

    case FETCH_VENUE_EXPERT_PAGE:
      return {
        ...state,
        venueexpert: action.venueexpert,
        isLoadingPage: action.isLoadingPage,
        isFetchingVenues: action.isFetchingVenues,
        pageNum: action.pageNum,
        totalCount: action.totalCount,
        venueList: action.venueList,
      };

    case LOAD_MORE_VENUELIST_EXPERT_PAGE:
      let newList = state.venueList.concat(action.venueList);
      return {
        ...state,
        pageNum: action.pageNum,
        venueList: newList,
        isFetchingVenues: action.isFetchingVenues,
        totalCount: action.totalCount,
      };

    case LOADING_MORE_VENUELIST_EXPERT_PAGE:
      return {
        ...state,
        isFetchingVenues: action.isFetchingVenues,
      };

    default:
      return state;
  }
};

// Export Reducer
export default VenueExpertReducers;
